export const useLegacyStyles = () => {
  return {
    container: 'container mx-auto px-4',
    card: 'bg-white dark:bg-gray-800 rounded-lg shadow-lg',
    button: 'px-4 py-2 rounded-lg transition-colors',
    primaryButton: 'bg-primary text-white hover:bg-primary-dark',
    secondaryButton: 'bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-300',
    memoryCard: 'bg-white dark:bg-gray-800 rounded-lg shadow-lg p-4 hover:shadow-xl transition-shadow',
  };
};